import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

const ClusterSegmentComparisonTable = ({ rowData }) => {
  rowData = Object.fromEntries(Object.entries(rowData).filter(([key]) => key !== 'statement'));
  return (
    <div key={uuid()} className="c-table--row" data-test="clusterSegCompTableComponent">
      <div className="c-table-private-col">
        <div className="c-table--col">
          <div className="cell-content">
            {Object.values(rowData).map(cellValue => (<div key={uuid()} className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={cellValue}
              >{cellValue}
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

ClusterSegmentComparisonTable.propTypes = {
  rowData: PropTypes.instanceOf(Object),
};

export default ClusterSegmentComparisonTable;
